import { getAceFormGroupNames } from "./ace-form-group.get-names";
import { h } from "@stencil/core";
import { JsonParser } from "../../utils";
import xss, { whiteList } from "xss";
export class AceFormGroup {
    constructor() {
        // Define whitelist for error HTML input.
        this.xssOptions = {
            whiteList: Object.assign(Object.assign({}, whiteList), { 'ace-notification': ['type', 'theme', 'href', 'icon-name', 'text', 'target'] }),
        };
        this.errors = undefined;
        this.label = undefined;
    }
    componentWillLoad() {
        var _a;
        this.names = getAceFormGroupNames((_a = this.hostElement) === null || _a === void 0 ? void 0 : _a.id);
        this.parseErrors();
    }
    parseErrors() {
        this._errors = new JsonParser(this.errors, []).getValue();
        const hasErrors = this._errors && this._errors.length > 0;
        this.setErrorStateForFormInputs(hasErrors);
    }
    renderErrors() {
        if (this._errors && this._errors.length > 0) {
            return (h("div", { class: this.names.CLASS.ERRORS }, this._errors.map((error, index) => {
                const id = error.id ? error.id : `error_${index}`;
                return (h("ace-text", { id: id, key: id, tag: 'div', type: 'label', size: 'small', weight: 'semibold', color: 'surface-semantic--error', innerHTML: xss(error.message, this.xssOptions) }));
            })));
        }
    }
    // If errors are defined, all form components of type AceInput, AceCheckbox, AceRadioButton & AceSelect will be rendered within errror state.
    setErrorStateForFormInputs(newState) {
        const formInputs = this.hostElement.querySelectorAll('ace-input, ace-select, ace-checkbox, ace-radio-button');
        formInputs.forEach(input => {
            input.setAttribute('has-errors', newState.toString());
        });
    }
    render() {
        return (h("div", { key: '6798caa42cfd6f66702a800405e8584e219590db', id: this.names.ID.ROOT, class: this.names.CLASS.ROOT }, this.label ? h("ace-text", { class: this.names.CLASS.HEADLINE, tag: 'span', type: 'body', weight: 'semibold', color: 'text-neutral--secondary', innerHTML: this.label }) : null, h("slot", { key: '92f31fea63e5be9608453ec50005ece6a1763241' }), this.renderErrors()));
    }
    static get is() { return "ace-form-group"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["./ace-form-group.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ace-form-group.css"]
        };
    }
    static get properties() {
        return {
            "errors": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "IError[] | string",
                    "resolved": "IError[] | string",
                    "references": {
                        "IError": {
                            "location": "import",
                            "path": "../../types",
                            "id": "src/types.ts::IError"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Array of errors to be shown below the form group component.\nThis array should include an object for each error, with the format: {\"id\": \"id_for_html_element\", \"message\": \"Error message to show to the user\"}."
                },
                "attribute": "errors",
                "reflect": false
            },
            "label": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The label to be shown as part of this form group. Hidden if not passed."
                },
                "attribute": "label",
                "reflect": false,
                "defaultValue": "undefined"
            }
        };
    }
    static get elementRef() { return "hostElement"; }
    static get watchers() {
        return [{
                "propName": "errors",
                "methodName": "parseErrors"
            }];
    }
}
//# sourceMappingURL=ace-form-group.js.map
